import React from 'react';
import { useTranslation } from 'react-i18next';
import { centsToDollarsNumber } from '../../../../lib/util';
import styles from './ProductTitle.module.scss';
import { useLocale } from '../../../../contexts/LocaleContext';

interface FlatPrice {
  priceInCents: number;
}

interface LowestSubscriptionBundlePrice {
  cheapestSubscriptionRate: string;
  cheapestSubscriptionRateUnit: string;
}

export type ProductTitlePrice = FlatPrice | LowestSubscriptionBundlePrice;

interface ProductTitleProps {
  productName: string;
  price: ProductTitlePrice;
}

function priceIsBundlePrice(price: ProductTitlePrice): price is LowestSubscriptionBundlePrice {
  return 'cheapestSubscriptionRate' in price;
}

export default function ProductTitle({ productName, price }: ProductTitleProps) {
  const { t } = useTranslation();
  const { currencyFormatter } = useLocale();
  const priceCopy = priceIsBundlePrice(price)
    ? t('starting_at_rate_unit', { rate: price.cheapestSubscriptionRate, unit: price.cheapestSubscriptionRateUnit })
    : currencyFormatter.format(centsToDollarsNumber(price.priceInCents));

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{productName}</h2>
      <span className={styles.price}>{priceCopy}</span>
    </div>
  );
}
